module.exports = __webpack_public_path__ + "img/06-min.a3529980.jpg";